import { useQuery } from '@tanstack/react-query';
import campaignService from 'v2/services/campaigns';
import type { CampaignLinkType } from 'v2/services/campaigns';

export function useListProductCampaigns(
  productId: number,
  type: CampaignLinkType,
  pagination: { current_page: number; per_page: number },
  filters?: Record<string, unknown>
) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['productCampaigns', productId, type, pagination.current_page, pagination.per_page, filters],
    queryFn: () => campaignService.listProductCampaigns({ productId, pagination, type, filters }),
    enabled: !!productId,
    staleTime: 30 * 1000
  });

  return { data, isLoading, error, refetch };
}
